<template>
    <div class="card">
        <div class="card-header">
            <p class="card-title"> Informes Autocitas</p>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-2">
                </div>
                <div class="col-md-2">
                    <Calendar style="width: 100%;" v-model="fecha_ini" dateFormat="dd/mm/yy"/>
                </div>
                <div class="col-md-2">
                    <Calendar style="width: 100%;" v-model="fecha_fin" dateFormat="dd/mm/yy"/>
                </div>
                <div class="col-md-2">
                    <select v-model="tipo_fecha" class="form-control">
                        <option value="fecha_visita">Fecha visita</option>
                        <option value="fecha_crear_visita">Fecha creación</option>
                    </select>
                </div>
                <div class="col-md-2 row">
                    <div class="col-md-8">
                        <select v-model="estado" class="form-control">
                            <option value="">Todas</option>
                            <option value="SI">Aceptadas</option>
                            <option value="NO">Denegadas</option>
                            <option value="SIN ACCIÓN">Sin acción</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <button class="btn btn-primary" @click="enviarForm">Enviar</button>
                    </div>
                </div>
                <div class="col-md-2">
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Nº Expediente</th>
                        <th>Origen</th>
                        <th>Comunicación</th>
                        <th>Operario</th>
                        <th>Fecha creación</th>
                        <th>Aceptada</th>
                        <th>Usuario</th>
                        <th>Fecha inicio</th>
                        <th>Fecha fin</th>
                        <th>Fecha en domicilio</th>
                        <th>Fecha realizada</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="auto in autovisitas" :key="auto">
                        <td>{{ auto.expediente }}</td>
                        <td>{{ auto.origen }}</td>
                        <td>{{ auto.tipo_envio }}</td>
                        <td>{{ auto.operario }}</td>
                        <td>{{ auto.fecha_mensaje }} {{ auto.hora_mensaje }}</td>
                        <td v-if="auto.aceptada == 'SI' && auto.reconfigurada == 'SI'">
                            SI {{ auto.fecha_aceptada }} [reconfigurada]
                        </td>
                        <td v-else-if="auto.aceptada == 'SI'">
                            SI {{ auto.fecha_aceptada }}
                        </td>
                        <td v-else-if="auto.aceptada == 'NO' && auto.reconfigurada == 'SI'">
                            NO {{ auto.fecha_aceptada }} [reconfigurada]
                        </td>
                        <td v-else-if="auto.aceptada == 'NO'">
                            NO {{ auto.fecha_aceptada }}
                        </td>
                        <td v-else>
                            {{ auto.aceptada }} 
                        </td>
                        <td>{{ auto.usuario }}</td>
                        <td>{{ auto.fecha }}</td>
                        <td>{{ auto.fecha_fin }}</td>
                        <td v-if="auto.operario_en_domicilio_fecha_visita == 0">
                            -
                        </td>
                        <td v-else>
                            {{ auto.operario_en_domicilio_fecha_visita }}
                        </td>
                        <td v-if="auto.fecha_unix_realizado == 0">-</td>
                        <td v-else>{{ auto.fecha_unix_realizado }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div style="margin-left: 15px;">            
            <p>Autovisitas: {{ autovisitasnum }}</p>
            <p>Aceptadas: {{ aceptadas }} {{ aceptadasporciento }}</p>
            <p>Denegadas: {{ denegadas }} {{ denegadasporciento }}</p>
            <p>Sinacción: {{ sin_accion }} {{ sin_accionporciento }}</p>            
        </div>
    </div>
</template>
<script>
import Calendar from 'primevue/calendar';
import { PwgsApi } from '../../../services/PwgsApi';
export default {
    props: [],
    data() {
        return {
            aceptadasporciento: '',
            denegadasporciento: '',
            sin_accionporciento: '',
            tipo_fecha: 'fecha_visita',
            fecha_ini: new Date(),
            fecha_fin: new Date(),
            estado: '',
            autovisitasnum:'',
            aceptadas:'',
            denegadas:'',
            sin_accion:'',
            autovisitas:[],
        }
    },
    components: {
        Calendar,
    },
    methods:{
        async enviarForm(){
            const api = new PwgsApi();
            this.fecha_ini.setHours(0, 0, 0, 0);
            this.fecha_fin.setHours(23, 59, 59, 999);
            const resp = await api.post('informes/1/autovisitas', {
                tipo_fecha: this.tipo_fecha, 
                fecha_ini: this.fecha_ini, 
                fecha_fin:this.fecha_fin, 
                estado_autovisita: this.estado,
            });
            
            this.autovisitas = resp;
            this.aceptadas = 0;
            this.denegadas = 0;
            this.sin_accion = 0;
            for(let auto of this.autovisitas){
                if(auto.aceptada == 'SI') this.aceptadas++;
                if(auto.aceptada == 'NO') this.denegadas++;
                if(auto.aceptada == 'SIN ACCIÓN') this.sin_accion++;                
            }
            this.autovisitasnum = this.autovisitas.length;
            if(this.autovisitasnum == 0){
                this.aceptadasporciento = '';
                this.denegadasporciento = '';
                this.sin_accionporciento = '';
            }else{
                this.aceptadasporciento = '('+((this.aceptadas/this.autovisitasnum)*100).toFixed(2)+'% )';
                this.denegadasporciento = '('+((this.denegadas/this.autovisitasnum)*100).toFixed(2)+'% )';
                this.sin_accionporciento = '('+((this.sin_accion/this.autovisitasnum)*100).toFixed(2)+'% )';
            }
        }
    }
}
</script>